import { ModelBase } from '../../core/model/model-base';

export class DirectDebitLog extends ModelBase {
  contactName: string;
  companyName: string;
  invoiceNumber: string;
  payerNumber: string;
  createdAt: Date;
  isError: boolean;
  description: string;
}
